import css from 'styled-jsx/css';
import { screen, colors } from 'components/styles/variables';

export const styles = css`
  .desktop-text-search-container {
    display: none;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0 16px;
    box-shadow: 0 5px 10px ${colors.G2};
    border-radius: 16px;
    border: 1px solid ${colors.G2};
    height: 64px;
    margin-bottom: 16px;
    max-height: 64px;
    box-shadow: 0px 5px 16px rgba(0, 0, 0, 0.1);
  }

  @media (min-width: ${screen.smMin}) {
    .desktop-text-search-container {
      display: flex;
      max-width: 1038px;
      width: 100%;
    }
  }

  .divider {
    width: 1px;
    height: 42px;
    background-color: ${colors.G2};
    margin-left: 8px;
  }
`;

export default styles;
